import script from "./RedeemCodeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RedeemCodeView.vue?vue&type=script&lang=ts&setup=true"

import "./RedeemCodeView.vue?vue&type=style&index=0&id=58251d50&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58251d50"]])

export default __exports__